
export default {
  props: ['error'],
  layout(context) {
    const { app } = context

    return app.nuxt.err?.statusCode === 404 ? 'empty' : 'default'
  },
}
